import { FALLBACK_DEFAULT_CURRENCY } from "slices/currency/constants";

export const readOnlyField = (key, label, value) => ({
  key,
  label,
  value: value || "-",
  editable: false,
});

export const textField = (key, label, formData, onChangeValue, extra = {}) => ({
  key,
  label,
  type: "text",
  value: formData?.[key],
  onChange: onChangeValue(key),
  ...extra,
});

export const dateField = (key, label, formData, onChangeValue, extra = {}) => ({
  ...textField(key, label, formData, onChangeValue, extra),
  type: "date",
});

export const currencyField = (
  key,
  label,
  formData,
  onChangeValue,
  extra = {}
) => ({
  key,
  label,
  type: "currency",
  placeholder: "e.g. 250000",
  value: formData?.[key],
  onChange: onChangeValue(key),
  currencyCode: FALLBACK_DEFAULT_CURRENCY.code,
  ...extra,
});

export const externalLinkField = (formData, onChangeValue) =>
  textField("externalLink", "External Link", formData, onChangeValue, {
    placeholder: "https://",
  });
